import { useMutation } from "@apollo/client"

import { graphql } from "@/main/gql/__generated__"
import { useStoreManagementMutation } from "@/provider/apollo/Apollo"

const switchSalonMutation = graphql(/* GraphQL */ `
	mutation SwitchSalon($salonId: Int!) {
		switchSalon(salonId: $salonId) {
			salon {
				id
			}
		}
	}
`)

const useSwitchSalon = () => {
	const [mutate] = useMutation(switchSalonMutation)

	const switchSalon = async (newSalonId: number) => {
		// NOTE: ここでは Rh-Salon-Id が switch 前のものが渡ってしまうが、特に問題はない。
		// reload 後、ただちに呼ばれる GetMe や Login により新しい店舗の情報が表示される。
		await mutate({ variables: { salonId: newSalonId } }).catch((error) => {
			console.error(error)
			throw new Error("店舗の切り替えに失敗しました")
		})
		// サロン切り替え時はクエリパラメータをリセットする
		window.location.href = window.location.pathname
	}

	return switchSalon
}

export default useSwitchSalon

/**
 * souhl_admin 用: store-management supergraph の switchSalon mutation を実行するフック。
 * mutation document を内部に閉じ込める。
 */
export const useSwitchSalonForStoreManagement = () => {
	const [mutate] = useStoreManagementMutation(switchSalonMutation)

	const switchSalon = async (salonId: number) =>
		await mutate({ variables: { salonId } }).catch((error) => {
			console.error("店舗の切り替えに失敗しました", error)
			throw error
		})

	return switchSalon
}
